// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__o69_R","photobanner":"styles_photobanner__ISKxk","bannermove":"styles_bannermove__jFQXq"};